import { Toolbar, Typography, AppBar, Box } from "@mui/material";
import { OperatorCraneNames } from "../OperatorCraneDisplay";
import { TimeAndUserMenu } from "@dexteel/mesf-core";

export const TopMenu = ({
  selectedCraneId,
  selectedOperatorId,
}: {
  selectedCraneId: number | null;
  selectedOperatorId: number | null;
}) => {
  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: (theme) => theme.palette.primary.main,
        color: "white",
        height: "56px",
        "& .MuiToolbar-root": {
          height: "56px",
          padding: (theme) => theme.spacing(1),
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        },
      }}
    >
      <Toolbar>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: "1.5rem",
          }}
        >
          Billet Yard Inventory
        </Typography>
        <Box>
          <OperatorCraneNames
            selectedCraneId={selectedCraneId || null}
            selectedOperatorId={selectedOperatorId || null}
          />
        </Box>
        <Box>
          <TimeAndUserMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
};
